import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
const { processAlertMessage } = require('../accessibility/accessibilityHelper');

const reassuranceMessageCarousel = {
    elements: {
        $document: $(document),
    },

    selectors: {
        carousel: '.js-reassurance-message-carousel',
    },

    settings: {
        carouselParameters:
        {
            modules: [Pagination],
            centeredSlides: true,
            slidesPerView: 'auto',
            pagination: {
                el: ".js-reassurance-message-pagination",
                clickable: true,
                renderBullet: function (index) {
                    return `<button type="button" class="swiper-pagination-bullet" aria-label="Go to slide ${index + 1}"></button>`;
                },
            },
            on: {
                slideChangeTransitionEnd(swiper) {
                    processAlertMessage('Showing reassurance message carousel slide ' + (swiper.realIndex + 1), true);
                }
            }
        }
    },

    init() {
        this.initCarousel();
    },

    initCarousel() {
        new Swiper(this.selectors.carousel, this.settings.carouselParameters);
    }
};

reassuranceMessageCarousel.init();